import React from 'react';

import { ICONS_MAP } from 'constants/icons';

import { IconContainer, ISwitchProps, StyledSwitch } from './styled';

interface ICustomSwitchProps extends ISwitchProps {
  checkedIcon?: React.ReactElement;
  notCheckedIcon?: React.ReactElement;
}

const Switch = ({ checkedIcon, notCheckedIcon, ...restProps }: ICustomSwitchProps) => {
  const renderIcon = (isChecked: boolean) => {
    if (isChecked) {
      return (
        <IconContainer>{checkedIcon || <ICONS_MAP.Check width={7} />}</IconContainer>
      );
    }

    return (
      <IconContainer>{notCheckedIcon || <ICONS_MAP.Close width={7} />}</IconContainer>
    );
  };

  return <StyledSwitch {...restProps} renderIcon={renderIcon} />;
};

export default Switch;
